import type { CartItemCardWithAddCartFormProps } from './type'

import { OrderUpdItem } from '@/api/@types'
import {
  CartItemOrderCard,
  CartItemOrderDetailModal,
  CartItemOrderEditModal,
} from '@/components/features/cart'
import {
  useUpdateCartItem,
  cartKeyFactory,
  useDeleteCartItem,
} from '@/hooks/features/cart'
import { useModal } from '@/hooks/util'
import { queryClient } from '@/lib/react-query'

export const CartItemCardWithAddCartForm = ({
  cartItem,
  isVisiblePurchasePrice = false,
}: CartItemCardWithAddCartFormProps) => {
  const detailModal = useModal()
  const editModal = useModal()

  const mutator = useUpdateCartItem({
    config: {
      onSuccess: () => {
        // Note: カート内の更新
        queryClient.invalidateQueries(cartKeyFactory.all)

        editModal.close()
      },
    },
  })

  const deleter = useDeleteCartItem({
    config: {
      onSuccess: () => {
        // Note: カート内の更新
        queryClient.invalidateQueries(cartKeyFactory.all)
      },
    },
  })

  const handleOpenEditModal = () => {
    detailModal.close()
    editModal.open()
  }

  const handleDeleteItem = () => {
    deleter.mutateAsync({
      itemCode: cartItem.item.itemCode,
    })
  }

  const handleEditItem = (data: OrderUpdItem[]) => {
    if (data.length === 0) return
    mutator.mutateAsync({
      data: data[0],
    })
  }

  return (
    <div>
      <div>
        <CartItemOrderCard
          item={cartItem.item}
          salesTypeQuantities={cartItem.salesTypeQuantities}
          isLoadingDelete={deleter.isLoading}
          isVisiblePurchasePrice={isVisiblePurchasePrice}
          onClickEdit={editModal.open}
          onClickDetail={detailModal.open}
          onClickDelete={handleDeleteItem}
        />
        <CartItemOrderDetailModal
          item={cartItem.item}
          salesTypeQuantities={cartItem.salesTypeQuantities}
          editable
          isVisiblePurchasePrice={isVisiblePurchasePrice}
          isOpen={detailModal.isOpen}
          onClose={detailModal.close}
          onOpenEdit={handleOpenEditModal}
        />
        <CartItemOrderEditModal
          cartItem={cartItem}
          disabled={
            cartItem.item.itemStatus !== 'available' &&
            cartItem.item.itemStatus !== 'forbidden' // 検索不可・購入可の場合は編集有効
          }
          isVisiblePurchasePrice={isVisiblePurchasePrice}
          isSubmittingEdit={mutator.isLoading}
          isSubmittingDelete={deleter.isLoading}
          isOpen={editModal.isOpen}
          onDelete={handleDeleteItem}
          onSubmit={handleEditItem}
          onClose={editModal.close}
        />
      </div>
    </div>
  )
}
